import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';

import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import kpiTrackerMessages from '../../core-utils/messages/kpiTrackerMessages';

import axios from 'axios';

import Loader from '../../_components/molecules/Loader';
import { pageScrollDown } from '../SummaryPage';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import KpiTrackerModal from '../../_components/organisms/KpiTrackerModal';
import { KPI_TRACKER_INTERNAL } from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import properties from '../../core-utils/properties';
import { formatKpiPrograms } from '../../core-utils/helper-utils/kpiTrackerHelper';
import { observer } from 'mobx-react';

const KpiTrackerPage = () => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    scrollBar: {
      '&::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
        backgroundColor: patientAccessTheme.palette.grey[300],
        borderRadius: '13px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: patientAccessTheme.palette.grey[300],
        borderRadius: '13px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: patientAccessTheme.palette.grey[500],
        borderRadius: '13px',
      },
    },
  });
  const { classes } = useStyles();
  const navigate = useNavigate();

  const [loadingKpiTracker, setLoadingKpiTracker] = useState<boolean>(false);
  const [openReportsModal, setOpenReportsModal] = useState(false);

  const [programData, setProgramData] = useState<any>([]);
  // const loginPageStore = useStores().loginPageStore;

  const getAllPrograms = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.kpiTrackerBaseUrl +
          properties.getAllPrograms,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        },
      )
      .then((res) => {
        if (res?.status === 200) {
          setProgramData(res?.data?.data);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const apiCalls = async () => {
    setLoadingKpiTracker(true);
    Boolean(startDate !== '' && endDate !== '')
      ? await Promise.all([getAllPrograms()]).then(() => {
          setLoadingKpiTracker(false);
        })
      : '';
    setLoadingKpiTracker(false);
  };

  const employerGroupStore = useStores().employerGroupStore;
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const [areDatesReady, setAreDatesReady] = useState<boolean>(false);

  // useEffects
  useEffect(() => {
    Boolean(startDate !== '' && endDate !== '') ? apiCalls() : '';
  }, [areDatesReady]);

  useEffect(() => {
    setStartDate(
      `${employerGroupStore?.employerGroupResponseData?.start_month} ${employerGroupStore?.employerGroupResponseData?.start_year}`,
    );
    setEndDate(
      `${employerGroupStore?.employerGroupResponseData?.end_month} ${employerGroupStore?.employerGroupResponseData?.end_year}`,
    );
    setAreDatesReady((prev) => !prev);
  }, []);

  const KpiTracker: React.FC = observer(({}) => {
    const [loader] = useState<any>(<Loader />);

    const handleSubmit = (program: string, timeMarkers: Array<any>) => {
      const selectedProgramObj = kpiPrograms.find(
        (item: any) => item.program === program,
      );

      if (selectedProgramObj) {
        const modifiedProgramObject = {
          program: selectedProgramObj.program,
          timeMarkers: timeMarkers,
          Kpis: selectedProgramObj.Kpis.map((kpi: any) => ({
            name: kpi.name,
            values: kpi.values,
            isChecked: kpi.selectedValues.length ? true : false,
            selectedValues: kpi.selectedValues,
          })).filter((item: any) => item.isChecked),
        };

        navigate(KPI_TRACKER_INTERNAL, {
          state: {
            selectedProgram: modifiedProgramObject,
          },
        });
      }
    };

    const handleChange = (program: string, index: number) => {
      setKpiPrograms((prevPrograms: any) => {
        const updatedPrograms = [...prevPrograms];
        const programIndex = updatedPrograms.findIndex(
          (val) => val.program === program,
        );

        if (programIndex !== -1) {
          const updatedKpis = [...updatedPrograms[programIndex].Kpis];
          updatedKpis[index].isChecked = !updatedKpis[index].isChecked;
          !updatedKpis[index].isChecked
            ? (updatedKpis[index].selectedValues = [])
            : '';

          updatedPrograms[programIndex] = {
            ...updatedPrograms[programIndex],
            Kpis: updatedKpis,
          };
        }

        return updatedPrograms;
      });
    };

    const handleSelectedValues = (
      program: string,
      index: number,
      kpis: any,
    ) => {
      setKpiPrograms((prevPrograms: any) => {
        const updatedPrograms = [...prevPrograms];
        const programIndex = updatedPrograms.findIndex(
          (val) => val.program === program,
        );
        if (programIndex !== -1) {
          const updatedKpis = [...updatedPrograms[programIndex].Kpis];
          updatedKpis[index].selectedValues = kpis;
          updatedPrograms[programIndex] = {
            ...updatedPrograms[programIndex],
            Kpis: updatedKpis,
          };
        }
        return updatedPrograms;
      });
    };
    const [kpiPrograms, setKpiPrograms] = useState<any>([]);
    useEffect(() => {
      programData.length
        ? setKpiPrograms(
            formatKpiPrograms(programData, handleChange, handleSelectedValues),
          )
        : '';
    }, [programData]);
    return (
      <div>
        {loadingKpiTracker ? (
          loader
        ) : (
          <>
            <KpiTrackerModal
              kpiPrograms={kpiPrograms}
              handleSubmit={handleSubmit}
            />
          </>
        )}
      </div>
    );
  });

  return (
    <div>
      <div className={classes.mainDiv}>
        <>
          <Box style={{ width: '1182px', position: 'relative' }}>
            <PageTitleAndSubTitle
              title={kpiTrackerMessages.pageTitles.title}
              subTitle={kpiTrackerMessages.pageTitles.subTitle.part1}
              subTitleStartPeriod={startDate}
              subTitleMiddleString={
                kpiTrackerMessages.pageTitles.subTitle.part2
              }
              subTitleEndPeriod={endDate}
              subTitleEndString={kpiTrackerMessages.pageTitles.subTitle.part3}
              showDownloadButton={true}
              downloadButtonAction={() => setOpenReportsModal(true)}
              // showQueryDataButton={checkUserAccess(
              //   UserAccessConstants.COHORT_DETAILS,
              //   loginPageStore.userResponse.role.name,
              //   loginPageStore.userFeatures,
              // )}
            />
          </Box>
        </>
        <Box
          sx={{
            marginTop: '60px',
          }}
        >
          <KpiTracker />
        </Box>
        <Box id="ScrollElement"></Box>
      </div>
      {pageScrollDown('ScrollElement')}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
};

export default KpiTrackerPage;
